import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  BODY_TYPES,
  EMPTY_FILTERS,
  VEHICLE_TYPES,
} from "../mockData";

export default function FreightFilters({ filters, onChange, onSearch, onClear, loading = false }) {
  const handleChange = (field) => (event) => {
    onChange({ ...filters, [field]: event.target.value });
  };

  const handleClear = () => {
    onChange({ ...EMPTY_FILTERS });
    onClear();
  };

  return (
    <Card className="lances-filters-card" elevation={0}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Nº do Frete"
              placeholder="Ex: 1779894457614"
              value={filters.number}
              onChange={handleChange("number")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Origem"
              placeholder="Ex: Belo Horizonte/MG"
              value={filters.origin}
              onChange={handleChange("origin")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Destino"
              placeholder="Ex: São Paulo/SP"
              value={filters.destination}
              onChange={handleChange("destination")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Tipo de Veículo</InputLabel>
              <Select
                label="Tipo de Veículo"
                value={filters.vehicleType}
                onChange={handleChange("vehicleType")}
              >
                <MenuItem value="">Todos</MenuItem>
                {VEHICLE_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Tipo de Carroceria</InputLabel>
              <Select
                label="Tipo de Carroceria"
                value={filters.bodyType}
                onChange={handleChange("bodyType")}
              >
                <MenuItem value="">Todos</MenuItem>
                {BODY_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Data da Coleta"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={filters.collectionDate}
              onChange={handleChange("collectionDate")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box className="lances-filters-actions">
              <Button variant="text" onClick={handleClear} className="lances-btn-clear" disabled={loading}>
                Limpar filtros
              </Button>
              <Button variant="contained" onClick={onSearch} className="lances-btn-search" disabled={loading}>
                Buscar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
